import React from "react";
import PieChart from "../../core/charts/PieChart";

const ScrollPieChart = (props) => {
	return <PieChart size={280} {...props} />;
};

export default ScrollPieChart;
